import { render, staticRenderFns } from "./TextTemplate.vue?vue&type=template&id=617bd2bb&scoped=true&"
import script from "./TextTemplate.vue?vue&type=script&lang=js&"
export * from "./TextTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TextTemplate.vue?vue&type=style&index=0&id=617bd2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bd2bb",
  null
  
)

export default component.exports